// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SkanAppsList-primaryButton-3xzr21","sector":"SkanAppsList-sector-159U6w"};